import { navigationRoutes } from '@app/utils/navigation-routes';
import RequiredAuth from '@app/routes/required-auth.route';
import { UserPage, UsersOutlet, UsersGroupsPage, QmUsersPage } from '@app/pages/users';
import { Route } from 'react-router-dom';
import React from 'react';
import UsersSynchronizationAD from '@app/pages/users/users-synchronization-AD';

export const usersRoutes = (
  <Route
    path={navigationRoutes.users}
    element={
      <RequiredAuth>
        <UsersOutlet />
      </RequiredAuth>
    }
  >
    <Route
      index
      element={
        <RequiredAuth>
          <UserPage />
        </RequiredAuth>
      }
    />
    <Route
      path={navigationRoutes.users_groups}
      element={
        <RequiredAuth>
          <UsersGroupsPage />
        </RequiredAuth>
      }
    />
    <Route
      path={navigationRoutes.qm_users}
      element={
        <RequiredAuth>
          <QmUsersPage />
        </RequiredAuth>
      }
    />
    <Route
      path={navigationRoutes.users_synchronization_AD}
      element={
        <RequiredAuth>
          <UsersSynchronizationAD />
        </RequiredAuth>
      }
    />
  </Route>
);
